import axiosFetch from './config';
export const getGroups = async () => {
  return axiosFetch({
    method: 'GET',
    url: `/groups?groupMemberType=ADMIN`,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const updateGroups = async (groupId, data) => {
  return axiosFetch({
    method: 'PUT',
    url: `/groups/${groupId}`,
    data,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const postGroups = async (data) => {
  return axiosFetch({
    method: 'POST',
    url: '/groups',
    data,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const updateGroupById = async (groupId, data) => {
  return axiosFetch({
    method: 'PUT',
    url: `/groups/${groupId}`,
    data,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const getMembersByGroupId = async (groupId) => {
  return axiosFetch({
    method: 'GET',
    url: `/groups/${groupId}/members`,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const deleteGroupById = async (groupId) => {
  return axiosFetch({
    method: 'DELETE',
    url: `/groups/${groupId}`,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const addMemberToGroup = async (groupId, data) => {
  return axiosFetch({
    method: 'POST',
    url: `/groups/${groupId}/members`,
    data,
    headers: {
      Authorization: 'Bearer ' + await localStorage.getItem('token'),
    }
  })
}

export const deleteMemberById = async (groupId, memberId) => {
  let token = localStorage.getItem('token')

  return axiosFetch({
    method: 'DELETE',
    url: `/groups/${groupId}/members`,
    data: {
      memberId: memberId
    },
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}